import algoliasearch from "algoliasearch/lite";
import tableSearch from "./../shared/tableSearch/tableSearch.vue";
import OrderApi from "../../../services/api/orderApi";
import MiscApi from "@/services/api/misc";
import Vue from "vue";
import { mapGetters } from "vuex";
import { breakPointsHelper } from "../../../components/mixin/breakPointsHelpers";
import BrandApi  from "@/services/api/brandApi"

const BrandApiService = new BrandApi(),
  OrderApiService = new OrderApi(),
  MiscApiService = new MiscApi();

export default {
  mixins: [breakPointsHelper],
  components: {
    tableSearch,
  },

  methods: {
    exportOrders,
    redirect,
    search,
    getOrders,
    retailerChangeCallback,
    statusChangeCallback,
    expand,
    getSuborders,
    updateTableData,
    changeStatus,
    updateChargeDate,
    adjustManuallyCharged,
    fetchOrderStatusOptions,
    navigateToRetailersProfile,
    pathToRetailerProfile,
    onRetailersFetched
  },

  data() {
    return {
      adjustmentInProgress: false,
      select_attribute: {
        highlight: {
          backgroundColor: "#FFF500",
          borderColor: "#FFF500",
        },
        contentStyle: {
          color: "black",
          backgroundColor: "#FFF500",
        },
      },
      theme_styles: {
        dayCellNotInMonth: {
          opacity: 0.5,
        },
      },
      searchIndexRetailers: null,
      searchIndexOrders: null,
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      query: "",
      selectedStatus: "",
      selectedRetailer: "",
      orders: [],
      isTypingSearchQuery: false,
      statuses: [],
      pagination: {
        page: 1,
        limit: 12,
        totalCount: 0,
      },
      tabLinks: [{ name: "Orders", path: "orders", routeName: "orders" }],
    };
  },

  beforeMount() {
    this.searchIndexOrders = this.algoliaClient.initIndex(this.$env.getOrigin() + "_orders");
    this.searchIndexSuborders = this.algoliaClient.initIndex(this.$env.getOrigin() + "_suborders");

    if (this.user.role !== "BRAND") {
      this.tabLinks.push({ name: "Custom Assortments", path: "custom-assortments", routeName: "customAssortments" });
    }

    this.updateTableData(this.$route.query.page);
    this.fetchOrderStatusOptions();

  },

  computed: {
    ...mapGetters({
      user: "userState",
    }),
    showPayoutDate() {
      return this.user.role === "ADMIN" || this.user.role !== "BRAND" ? true : false;
    },
  },
};

async function fetchOrderStatusOptions() {
  this.statuses = [
    { name: "ALL" },
    ...(await OrderApiService.getOrderStatuses()).data.options
      .map((status) => ({
        name: status.label,
      }))
      .filter((status) => !(status.name === "HOLD" || status.name === "VOID")),
  ];
}

function changeStatus(e, orderIndex, suborderIndex, suborderId) {
  e.preventDefault();
  const _self = this;

  _self.$loader.$emit("trigger", true);

  OrderApiService.changePaidStatus(suborderId)
    .then(() => {
      _self.orders[orderIndex].suborders[suborderIndex].is_manually_paid =
        !_self.orders[orderIndex].suborders[suborderIndex].is_manually_paid;
      _self.$forceUpdate();
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      _self.$loader.$emit("trigger", false);
    });
}

async function exportOrders() {
  try {
    this.$loader.$emit("trigger", true);

    let response;

    if (this.user.role === "ADMIN") {
      response = await OrderApiService.adminExportToCSV();
    } else if (this.user.role === "BRAND") {
      response = await OrderApiService.brandExportToCSV();
    }

    const url = window.URL.createObjectURL(new Blob([response.data])),
      link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", "bulletin_orders.csv");
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    if (error.response) {
      this.$swal("Attention", error.response.data.error_message);
    } else {
      this.$logger.notify(new Error(error));
    }
  } finally {
    this.$loader.$emit("trigger", false);
  }
}

function redirect(id) {
  let routeQuery = {
    page: this.pagination.page,
  };

  if (this.query.length) routeQuery.keyword = this.query;
  if (this.selectedRetailer) routeQuery.retailer = this.selectedRetailer.id;
  if (this.selectedStatus) routeQuery.status = this.selectedStatus.name;

  if (this.user.role === "ADMIN" || this.user.role === "RETAILER") {
    this.$router.push({
      name: "orderDetails",
      params: { orderId: id },
      query: routeQuery,
    });
  } else {
    this.$router.push({
      name: "suborderDetails",
      params: { suborderId: id },
      query: routeQuery,
    });
  }
}

function expand(index) {
  this.orders[index].isExpanded = !this.orders[index].isExpanded;
}

function search(val) {
  this.pagination.page = 1;
  this.query = val;

  this.updateTableData();
}

function statusChangeCallback(val) {
  if (val === "ALL") {
    this.selectedStatus = "";
  } else {
    this.selectedStatus = val;
  }

  this.pagination.page = 1;

  this.updateTableData();
}

function retailerChangeCallback(val) {
  if (val === "ALL") {
    this.selectedRetailer = "";
  } else {
    this.selectedRetailer = val;
  }

  this.pagination.page = 1;

  this.updateTableData();
}

// TODO it may not be necessary, probably this is just a legacy copy-paste code, but it was there in the original getRetailer function
function onRetailersFetched(retailers) {
  const { query } = this.$route;
  if (query.page) {
    this.pagination.page = Number(query.page);
    if (query.keyword) this.query = query.keyword;
    if (query.retailer) {
      retailers.forEach(function (retailer) {
        if (retailer.id === query.retailer) {
          this.selectedRetailer = retailer;
        }
      });
    }

    if (query.status) {
      this.selectedStatus = {
        name: query.status,
      };
    }
    this.$forceUpdate();
  }
}

function getOrders(page) {
  if (page) this.pagination.page = Number(page);

  this.searchIndexOrders.clearCache();
  this.searchIndexOrders
    .search({
      query: this.query,
      page: this.pagination.page - 1,
      hitsPerPage: this.pagination.limit,
      facets: "*",
      facetFilters: [
        this.user && this.user.role === "RETAILER" ? "retailer_id:" + this.user.retailer_id : "",
        this.selectedStatus === "" || this.selectedStatus.name === "ALL"
          ? []
          : "suborders.status:" + this.selectedStatus.name,
        this.selectedRetailer === "" || this.selectedRetailer.name === "ALL"
          ? []
          : "retailer_name:" + this.selectedRetailer.name,
      ],
    })
    .then((response, err) => {
      if (err) {
        this.$swal("Attention", _self.$utils.formatErrorMessage("orders"));

        return;
      }

      let orders = response.hits;

      orders.forEach(function (order) {
        Vue.set(order, "isExpanded", false);
      });

      this.pagination.totalCount = response.nbHits;
      this.orders = orders;
    });
}

function getSuborders(page) {
  if (page) this.pagination.page = page;

  this.searchIndexSuborders.clearCache();
  this.searchIndexSuborders
    .search({
      query: this.query,
      page: this.pagination.page - 1,
      hitsPerPage: this.pagination.limit,
      facets: "*,brand_id,status,retailer_name",
      facetFilters: [
        "brand_id:" + this.user.brand_id,
        this.selectedStatus === "" || this.selectedStatus.name === "ALL"
          ? [
              "status: DECLINED",
              "status: EXPIRED",
              "status: PENDING",
              "status: APPROVED",
              "status: FULFILLMENT_IN_PROGRESS",
              "status: PARTIALLY_FULFILLED",
              "status: SHIPPED",
              "status: PAID",
            ]
          : "status:" + this.selectedStatus.name,
        this.selectedRetailer === "" || this.selectedRetailer.name === "ALL"
          ? []
          : "retailer_name:" + this.selectedRetailer.name,
      ],
    })
    .then((response, err) => {
      if (err) {
        this.$swal("Attention", _self.$utils.formatErrorMessage("suborders"));

        return;
      }

      this.pagination.totalCount = response.nbHits;
      this.orders = response.hits;
    });
}

function updateTableData(page) {
  if (page) {
    this.$router.replace({
      name: "orders",
      query: { page: page },
    });
  }

  switch (this.user.role) {
    case "RETAILER":
    case "ADMIN":
      this.getOrders(page);
      break;

    case "BRAND":
      this.getSuborders(page);
      break;
  }
}

function adjustManuallyCharged(orderIndex, suborderIndex, suborderId) {
  this.$loader.$emit("trigger", true);
  this.adjustmentInProgress = true;

  this.orders[orderIndex].suborders[suborderIndex].manually_charged = true;

  OrderApiService.adjustManuallyCharged(suborderId)
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$logger.notify(new Error(error));
      }

      this.orders[orderIndex].suborders[suborderIndex].manually_charged = false;
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
      this.adjustmentInProgress = false;
    });
}

function updateChargeDate(date, orderIndex, suborderIndex, suborderId) {
  this.$loader.$emit("trigger", true);

  OrderApiService.adjustChargeDate(suborderId, date)
    .then((res) => {
      this.updateTableData();
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$logger.notify(new Error(error));
      }
    })
    .finally(() => {
      this.$loader.$emit("trigger", false);
    });
}

function navigateToRetailersProfile(retailerId) {
  this.$router.push({
    path: this.pathToRetailerProfile(retailerId),
  });
}

function pathToRetailerProfile(retailerId) {
  const baseRoute = this.user.role === "ADMIN" ? "profile" : "/retailer";
  return `${baseRoute}/${retailerId}`
}
